import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import PaycentralTransactionSection from "../../Sections/PaycentralTransactions";

const PaycentralTransactionComponent = () => {
    return (
        <Dashboard
            sectionName={<PaycentralTransactionSection />}
        />
    );
};

export default PaycentralTransactionComponent;
